import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconStackHorizontalAltFour16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconStackHorizontalAltFour16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M3.25 8a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m1 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m2 .5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m0 1a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m4-1.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m1 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m2.5 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m1 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconStackHorizontalAltFour16);
